import React, { useState } from "react";
import { 
  Cloud, 
  FileText, 
  Download, 
  Upload, 
  Folder, 
  Sparkles, 
  Lock,
  Search
} from "lucide-react";
import { toast } from "sonner";

export const LodgeFilesView = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const files = [
    {
      id: "f1",
      name: "Ritual_Grau_1_Aprendiz_REAA.pdf",
      category: "Rituais",
      degree: "1 - Aprendiz",
      size: "2.4 MB",
      date: "10/05/2026"
    },
    {
      id: "f2",
      name: "Prancha_Simbolismo_Pedra_Bruta.docx",
      category: "Peças de Arquitetura",
      degree: "1 - Aprendiz",
      size: "850 KB",
      date: "15/05/2026"
    },
    {
      id: "f3",
      name: "Ritual_Grau_2_Companheiro_REAA.pdf",
      category: "Rituais",
      degree: "2 - Companheiro",
      size: "3.1 MB",
      date: "20/05/2026"
    },
    {
      id: "f4",
      name: "Estudo_Cinco_Ordens_Arquitetura.pdf",
      category: "Peças de Arquitetura",
      degree: "2 - Companheiro",
      size: "1.8 MB",
      date: "22/05/2026"
    },
    {
      id: "f5",
      name: "Estatuto_Social_e_Regimento_Interno_Luz_e_Harmonia.pdf",
      category: "Legislação",
      degree: "Todos",
      size: "4.5 MB",
      date: "01/01/2026"
    },
    {
      id: "f6",
      name: "Balancete_Financeiro_Primeiro_Trimestre_2026.pdf",
      category: "Tesouraria",
      degree: "3 - Mestre",
      size: "1.2 MB",
      date: "10/04/2026"
    }
  ];

  const filtered = files.filter(f => 
    f.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDownload = (fileName) => {
    toast.success(`Download de "${fileName}" iniciado.`);
  };

  return (
    <div className="space-y-6" data-testid="lodge-files-view">
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-serif font-bold text-white">Arquivos em Nuvem & Biblioteca Maçônica</h2>
          <p className="text-xs text-slate-400">
            Repositório de rituais, pranchas de arquitetura, atas digitalizadas e regulamentos da Oficina
          </p>
        </div>

        <button
          onClick={() => toast.info("Selecione um arquivo PDF ou DOCX para upload.")}
          className="flex items-center space-x-1.5 bg-[#D4AF37] hover:bg-[#C5A028] text-slate-950 font-bold px-4 py-2.5 rounded-xl text-xs uppercase tracking-wider transition-all shadow-[0_0_15px_rgba(212,175,55,0.25)]"
        >
          <Upload className="w-4 h-4" />
          <span>Enviar Novo Documento</span>
        </button>
      </div>

      {/* Search */}
      <div className="luxury-card p-4">
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            placeholder="Buscar por nome do arquivo ou categoria..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-[#080D18] text-xs text-white placeholder-slate-500 pl-10 pr-4 py-2.5 rounded-xl border border-slate-700 focus:border-[#D4AF37]"
          />
        </div>
      </div>

      {/* Files Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((file) => (
          <div key={file.id} className="luxury-card p-5 space-y-3 hover:border-[#D4AF37]/60 transition-all flex flex-col justify-between">
            <div>
              <div className="flex items-start justify-between mb-2">
                <div className="w-10 h-10 rounded-xl bg-blue-500/15 text-blue-400 flex items-center justify-center border border-blue-500/30">
                  <FileText className="w-5 h-5" />
                </div>
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 font-mono">
                  {file.degree}
                </span>
              </div>

              <h4 className="font-semibold text-sm text-white line-clamp-1">{file.name}</h4>
              <span className="text-xs text-slate-400 block mt-0.5">{file.category}</span>
            </div>

            <div className="pt-3 border-t border-slate-800 flex items-center justify-between text-xs">
              <span className="text-slate-500 font-mono text-[11px]">{file.size} • {file.date}</span>
              <button
                onClick={() => handleDownload(file.name)}
                className="p-1.5 rounded-lg bg-[#080D18] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-slate-950 transition-colors"
                title="Baixar Documento"
              >
                <Download className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};
